import TreatmentFullLayout from "../../components/TreatmentLayout";

const RoboticUrology = () => {

const data = {
title:"Robotic Urology Surgery",
subtitle:"Advanced robotic surgery at BBMH Hospital",

heading:"Best Robotic Urology Treatment",
description:"Robotic urology surgery is the most advanced form of minimally invasive surgery used to treat complex urological conditions with high precision. At BBMH Hospital Bhilwara, patients receive expert care using modern surgical techniques ensuring faster recovery and excellent outcomes.",

image:"https://images.unsplash.com/photo-1580281657527-47f249e8f4df?q=80&w=1200",

sections:[
{
title:"What is Robotic Urology?",
content:"Robotic urology is a modern surgical technique where robotic arms assist the surgeon to perform highly precise procedures through very small incisions."
},
{
title:"Conditions Treated",
content:"",
list:[
"Prostate cancer",
"Kidney tumors",
"Bladder tumors",
"Ureter problems",
"Complex urology surgeries"
]
},
{
title:"Benefits of Robotic Surgery",
content:"",
list:[
"High precision",
"Less pain",
"Minimal bleeding",
"Small incisions",
"Faster recovery"
]
},
{
title:"Why Choose BBMH Hospital?",
content:"",
list:[
"8+ years experience",
"Advanced surgical care",
"High success rate",
"Modern equipment",
"Patient focused care"
]
}
],

faq:[
{q:"Is robotic surgery safe?",a:"Yes it is very safe and advanced."},
{q:"Recovery time?",a:"Recovery is faster than open surgery."},
{q:"Pain after surgery?",a:"Pain is minimal."}
]
};

return <TreatmentFullLayout data={data}/>
};

export default RoboticUrology;
